import React from 'react'
import styled, { useTheme } from 'styled-components'
import { Tag } from '../../components/generic/ui/Tag'

interface SidebarVersionProps {
  collapsed?: boolean
  version?: string
  hasNew?: boolean
  onVersionClick?: () => void
  onNewClick?: () => void
}

const SidebarVersion: React.FC<SidebarVersionProps> = ({
  collapsed = false,
  version,
  hasNew = false,
  onVersionClick,
  onNewClick,
}) => {
  const theme = useTheme()
  if (!version) return null

  const newBadge = hasNew ? (
    <NewButton type='button' onClick={onNewClick} aria-label='גרסה חדשה זמינה'>
      <Tag variant='tinted' color={theme.colors.accentDeep} shape='pill'>
        חדש
      </Tag>
    </NewButton>
  ) : null

  const clickable = !!onVersionClick

  return (
    <Strip $collapsed={collapsed}>
      <VersionButton
        as={clickable ? 'button' : 'span'}
        type={clickable ? 'button' : undefined}
        onClick={onVersionClick}
        $collapsed={collapsed}
        $clickable={clickable}
        aria-label={clickable ? 'הצג מה חדש' : undefined}
      >
        v{version}
      </VersionButton>
      {newBadge}
    </Strip>
  )
}

export default SidebarVersion

const Strip = styled.div<{ $collapsed: boolean }>`
  flex-shrink: 0;
  direction: rtl;
  display: flex;
  align-items: center;
  gap: 6px;
  border-top: 1px solid ${({ theme }) => theme.colors.line2};
  padding: ${({ $collapsed }) => ($collapsed ? '10px 8px' : '10px 14px')};
  flex-direction: ${({ $collapsed }) => ($collapsed ? 'column' : 'row')};
  justify-content: ${({ $collapsed }) => ($collapsed ? 'center' : 'space-between')};
`

const VersionButton = styled.button<{ $collapsed: boolean; $clickable: boolean }>`
  appearance: none;
  border: 0;
  background: transparent;
  padding: 2px 4px;
  border-radius: ${({ theme }) => theme.radii.sm};
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};
  font-family: ${({ theme }) => theme.fonts.mono};
  font-size: ${({ $collapsed, theme }) => ($collapsed ? '10px' : theme.text.sm)};
  color: ${({ theme }) => theme.colors.ink3};
  letter-spacing: 0.02em;
  white-space: nowrap;
  transition:
    color ${({ theme }) => theme.motion.fast} ease,
    background ${({ theme }) => theme.motion.fast} ease;

  &:hover {
    color: ${({ theme, $clickable }) => ($clickable ? theme.colors.ink : theme.colors.ink3)};
    background: ${({ theme, $clickable }) => ($clickable ? theme.colors.line2 : 'transparent')};
  }
`

const NewButton = styled.button`
  appearance: none;
  border: 0;
  background: transparent;
  padding: 0;
  cursor: pointer;
  display: inline-flex;
`
